import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Browser from '@wetransfer/concorde-browser';

import I18n from '@module/i18n';
import Icon from '@component/icon';
import LanguagePicker from '@component/languagepicker';
import Analytics from '@module/analytics';

import { ABBEY } from '@constant/colors';

const popupOptions = {
  anchor: Browser.isMobile ? 'top' : 'bottom',
  offset: Browser.isMobile ? 15 : 10,
  adjustWidthToParent: false,
};

const logo = Browser.isMobile ? (
  <Icon type="Logo" width={33} color={ABBEY} />
) : null;
const iconSize = Browser.isMobile ? 16 : 20;

const footerNav = () => {
  return Browser.isMobile ? null : (
    <React.Fragment>
      <a
        title={I18n.t('panel.footer.terms')}
        href="/legal/terms"
        data-route-context="about"
      >
        {I18n.t('panel.footer.terms')}
      </a>
      <a
        title={I18n.t('panel.footer.press')}
        href={I18n.t('external_links.prco')}
        rel="external"
      >
        {I18n.t('panel.footer.press')}
      </a>
      <a
        title={I18n.t('panel.footer.jobs')}
        href={I18n.t('external_links.homerun')}
        rel="external"
      >
        {I18n.t('panel.footer.jobs')}
      </a>
    </React.Fragment>
  );
};

const trackClick = (target, route) => {
  if (route.path === '/about') {
    // Analytic team want to analyze social media traffic coming from about page
    Analytics.trackStructEvent({
      category: 'about_page',
      action: `click_${target}`,
    });
  }
};

export const Footer = ({ session, route }) => {
  const footerBar = (
    <footer className="footer">
      {logo}
      <div className="footer__nav">
        <LanguagePicker
          popupOptions={popupOptions}
          currentLanguage={session.language}
        />
        {footerNav()}
      </div>
      <span className="footer__social-links">
        <a
          title={I18n.t('panel.footer.twitter')}
          href={I18n.t('external_links.twitter')}
          rel="external"
          onClick={trackClick.bind(this, 'twitter', route)}
        >
          <Icon type="Twitter" width={iconSize} />
        </a>
        <a
          title={I18n.t('panel.footer.facebook')}
          href={I18n.t('external_links.facebook')}
          rel="external"
          onClick={trackClick.bind(this, 'facebook', route)}
        >
          <Icon type="Facebook" width={iconSize} />
        </a>
        <a
          title={I18n.t('panel.footer.instagram')}
          href={I18n.t('external_links.instagram')}
          rel="external"
          onClick={trackClick.bind(this, 'instagram', route)}
        >
          <Icon type="Instagram" width={iconSize} />
        </a>
        <a
          title={I18n.t('panel.footer.youtube')}
          href={I18n.t('external_links.youtube')}
          rel="external"
          onClick={trackClick.bind(this, 'youtube', route)}
        >
          <Icon type="Youtube" width={iconSize} />
        </a>
      </span>
    </footer>
  );

  return footerBar;
};

Footer.propTypes = {
  session: PropTypes.object.isRequired,
  route: PropTypes.object,
};

const mapStateToProps = ({ route, session }) => ({ route, session });
export default connect(mapStateToProps)(Footer);
